/* eslint-disable import/prefer-default-export */
// /styles/layout/Container.js
import styled from "styled-components";

const sizeMap = {
  lg: "1280px",
  xl: "1440px",
};

export const Container = styled.div`
  width: 100%;
  max-width: ${({ $size }) => sizeMap[$size] || "1120px"};
  margin: 0 auto;
  padding: 16px;

  @media (min-width: 768px) {
    padding: 24px;
  }
`;
